import {Application, Router, CurrentUser } from 'app/classes';
const angular = require('angular');

const OPENED = 'opened';
const CLOSED = 'closed';

export class SwitcherController implements ng.IController {

    public state: string;
    public isOpen: boolean = false;
    public apps: Array<Application>;
    public appFilter: string = '';
    public appFilterIndex: number = 0;
    public static $inject = [
        '$scope',
        '$Router',
        '$CurrentUser',
        'IconService',
        '$timeout',
        '$element'
    ];

    constructor(
        private $scope,
        private $Router: Router,
        private $CurrentUser: CurrentUser,
        private IconService,
        private $timeout,
        private $element) {
        
        this.$scope = $scope;
        this.$Router = $Router;
        this.$timeout = $timeout;
        this.$element = $element;

        this.$scope.$watch('ctrl.state', (val, oldVal) => {
            if (val && val !== oldVal) {
                this.isOpen = (val === OPENED);

                if(val === OPENED) {
                    // When the menu is opened, focus on the app filter
                    // to make quick filtering easier
                    this.$timeout(function() {
                        const $el = <HTMLElement>document.querySelector('#app-filter--input');
                        if($el) {
                            $el.focus();
                        }
                    });
                } else {
                    // When the menu is closed reset the app filter 
                    // and show all apps.
                    this.appFilter = '';
                    this.populateApps();
                }
            }
        });
    }

    public open() {
        this.appFilter = '';
        this.isOpen = true;
        this.state = OPENED;
        this.populateApps();
    }

    public close() {
        this.isOpen = false;
        this.state = CLOSED;
        this.appFilterIndex = 0;
        this.populateApps();
    }

    public launchApp(app: Application, $event: MouseEvent) {
        if (($event.metaKey || $event.altKey || $event.ctrlKey)) {
            return;
        }
        $event.preventDefault();
        this.$timeout(() => {
            this.appFilterIndex = 0;
            this.populateApps();
            document.querySelector('#the-drop').scrollTop = 0;
            this.$Router.goto(app.slug);
            this.close();
        }, 0);
    }

    public toggle($event: Event) {
        $event.stopPropagation();
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    public getImage(app) {
        const icon = this.IconService.getImage(app.logo.name);
        if (icon) {
            return (icon.svg || icon.png);
        }
        
    }
    public onAppFilterChange() {
        this.appFilterIndex = 0;
        this.populateApps();
    }
    public populateApps() {
        this.apps = [
            ...this.$CurrentUser.apps.filter(app => {
                // Filter out the launchpad app that isn't the built in one
                // We want the builtin one because it has the correct icon and
                // we are guaranteed to have it where users may not actually have
                // the permissions for launchpad admin. 
                return app.slug !== "launchpad" || (app.slug === "launchpad" && app.hardcoded === true);
            })
        ].filter((app) => {
            // Filter based on the quick search input
            const quickFilter = this.appFilter.trim();
            const filterOut = quickFilter.length !== 0 && app.name.toLowerCase().indexOf(this.appFilter.toLowerCase()) === -1;

            // Apply all filtering criteria, keeping Launchpad in this case since we included it ourselves
            return ((app.launchpad_display || app.slug==="launchpad") && !app.is_archived && !filterOut);
        });

    }
    public handleFilterKeyPress (e) {
        if(this.apps.length > 0) {
            if (e.which === 13) { // Enter key
                this.launchApp(this.apps[this.appFilterIndex], e);
            }
        }
    }
    public handleFilterKeyDown (e) {
        if(this.apps.length > 0) {
            if(e.which === 37) { // Left
                // Can't move before first in the list
                if (this.appFilterIndex - 1 > -1) {
                    this.appFilterIndex = this.appFilterIndex - 1;
                    this.populateApps();
                }
            } else if (e.which === 38 ) { // Up
                // Can't move before first in the list
                if (this.appFilterIndex - 3 > -1) {
                    this.appFilterIndex = this.appFilterIndex - 3;
                    this.populateApps();
                }
            } else if (e.which === 39) { // Right 
                // Can't move past end of list
                if (this.appFilterIndex + 1 < this.apps.length) {
                    this.appFilterIndex = this.appFilterIndex + 1;
                    this.populateApps();
                }
            } else if (e.which === 40) { // Down
                // Don't let it go below the end of the list
                if (this.appFilterIndex + 3 < this.apps.length) {
                    this.appFilterIndex = this.appFilterIndex + 3;
                    this.populateApps();
                }
            }
            
        }
    }
}
